var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseViverse = function SvgChooseViverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    fillRule: "evenodd",
    d: "M18.565 2.18a29.3 29.3 0 0 1 8.9 15.57c.708 3.353-1.384 6.823-4.66 7.85-2.801.88-5.714 1.2-8.804 1.2s-6.003-.32-8.8-1.2c-3.275-1.027-5.367-4.497-4.66-7.85 1.284-6.1 4.466-11.502 8.895-15.57a6.746 6.746 0 0 1 9.13 0m1.029 19.02c-1.71.533-3.707.8-5.597.8s-3.882-.267-5.59-.8c-2-.623-3.064-2.655-2.631-4.683a17.77 17.77 0 0 1 5.433-9.437 4.14 4.14 0 0 1 5.576 0 17.72 17.72 0 0 1 5.44 9.437c.432 2.028-.627 4.06-2.631 4.683",
    clipRule: "evenodd"
  })));
};
export default SvgChooseViverse;